const checkArray = arr => (Array.isArray(arr) ? arr : []);

export default checkArray;
